import { useEffect, useState } from "react";
import { X, Save, AlertTriangle } from "lucide-react";

/** Raw JSON editor for advanced users. Full story_context edit as JSON. */
export const RawJsonEditor = ({ open, initialValue, onSave, onClose, busy }) => {
  const [text, setText] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (open) {
      setText(JSON.stringify(initialValue || {}, null, 2));
      setError("");
    }
  }, [open, initialValue]);

  if (!open) return null;

  const save = () => {
    try {
      const parsed = JSON.parse(text);
      if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
        setError("Root must be a JSON object");
        return;
      }
      onSave(parsed);
    } catch (e) {
      setError(`Invalid JSON: ${e.message}`);
    }
  };

  return (
    <div className="mvp-drawer-backdrop" onClick={busy ? undefined : onClose}>
      <aside className="mvp-drawer mvp-drawer-wide" onClick={(e) => e.stopPropagation()} data-testid="raw-json-editor">
        <header className="mvp-drawer-head">
          <h3>Raw JSON Editor</h3>
          <button className="mvp-icon-btn" onClick={onClose} disabled={busy} aria-label="Close" data-testid="raw-json-close">
            <X size={18} />
          </button>
        </header>
        <div className="mvp-drawer-body">
          <p className="mvp-dim mvp-drawer-hint">
            Edit the entire story context as JSON. Root must be an object. Changes will be autosaved after you click Apply.
          </p>
          {error && (
            <div className="mvp-error mvp-raw-error" data-testid="raw-json-error">
              <AlertTriangle size={14} /> {error}
            </div>
          )}
          <textarea
            className="mvp-json-area"
            value={text}
            onChange={(e) => setText(e.target.value)}
            spellCheck={false}
            data-testid="raw-json-textarea"
          />
        </div>
        <footer className="mvp-drawer-foot">
          <button className="mvp-nav-ghost" onClick={onClose} disabled={busy} data-testid="raw-json-cancel-btn">
            Cancel
          </button>
          <button className="btn-primary mvp-cta-sm" onClick={save} disabled={busy} data-testid="raw-json-apply-btn">
            <Save size={14} /> {busy ? "Applying…" : "Apply Changes"}
          </button>
        </footer>
      </aside>
    </div>
  );
};
